/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
  mutation ContentTranslationUpdateMutation(
    $contentTranslationId: ID
    $contentTranslationIds: [ID!]
    $scriptIds: [ID]
    $regex: String
    $mcc: String
    $mnc: [String!]
    $suffix: String
    $prefix: String
    $globalTranslationKeyword: String
    $omitWords: [String!]
    $type: CUSTOMER_TYPE
    $strategy: CONTENT_TRANSLATION_STRATEGY
    $senderIdDirectoryId: ID
    $senderId: [ID]
    $keywordDirectoryId: ID
    $keywordId: [ID]
  ) {
    ContentTranslationUpdate(
      contentTranslationId: $contentTranslationId
      contentTranslationIds: $contentTranslationIds
      scriptIds: $scriptIds
      regex: $regex
      type: $type
      mcc: $mcc
      mnc: $mnc
      suffix: $suffix
      prefix: $prefix
      omitWords: $omitWords
      strategy: $strategy
      senderIdDirectoryId: $senderIdDirectoryId
      senderId: $senderId
      keywordDirectoryId: $keywordDirectoryId
      keywordId: $keywordId
      globalTranslationKeyword: $globalTranslationKeyword
    ) {
      id
      message
      status
    }
  }
`;
